import { render } from "./MobileFooter.vue?vue&type=template&id=5ea0a6cf&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=5ea0a6cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea0a6cf"]])

export default __exports__